export enum GasOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
